import { RegisteredComponent } from "@builder.io/sdk-react";

import { FooterComponent } from "@/components/Footer";
import { HeaderComponent } from "@/components/Header/Header.builder";

export const layoutCustomComponents: RegisteredComponent[] = [
  HeaderComponent,
  FooterComponent,
];
